module.exports = __webpack_public_path__ + "assets/icon-custom-project-deselected.bc26e5a1.svg";